export default "__VITE_ASSET__DQeLPG5Z__"